export const PADDING_OUTER = 0;
export const PADDING_INNER = 0.1;
export const PADDING_WITHIN = 0.1;
export const BOTTOM_MARGIN_OFFSET = 10;
export const LEFT_MARGIN_OFFSET = 5;
